module.exports = __webpack_public_path__ + "static/img/login-samu-05.963782e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-samu-05.png
// module id = eQVs
// module chunks = 4